import { CheckSquareTwoTone } from '@ant-design/icons';
import { theme } from 'antd';

const YesOption = () => {
    const { token } = theme.useToken();
    return (
        <div>
            <CheckSquareTwoTone twoToneColor={token.colorPrimary} />
        </div>
    );
};

export default YesOption;
